import { Text } from '../_legacy/Typography';

export const FieldError = ({ message }: { message: String }) =>
  message && (
    <Text weight="medium" size="base" className="text-secondary-300">
      {message}
    </Text>
  );
